export const BRAND = {
  name: 'Jupally Avenues',
  legal: 'Jupally Avenues Private Limited',
  partner: 'Sashreek Ventures LLP',
  tagline: 'Building Spaces · Creating Value',
  phones: ['+91 95051 00200', '+91 90001 45000'],
  address: ['Villa No. 9, Urban Villas', 'Gandipet, Ranga Reddy District – 500075', 'Telangana, India'],
};

export const NAV_LINKS = [
  { id: 'about', label: 'About' },
  { id: 'strength', label: 'Strength' },
  { id: 'projects', label: 'Projects' },
  { id: 'milestones', label: 'Milestones' },
  { id: 'contact', label: 'Contact' },
];

export const STATS = [
  { value: 405, suffix: '+', label: 'Acres Developed' },
  { value: 21, suffix: '+', label: 'Completed Projects' },
  { value: 3, suffix: '', label: 'Ongoing Developments' },
];

export const CORE_VALUES = [
  { name: 'Integrity', desc: 'Every transaction built on transparency, ethics and trust.' },
  { name: 'Quality', desc: 'Engineering excellence and superior workmanship in every project.' },
  { name: 'Innovation', desc: 'Modern planning with future-ready infrastructure.' },
  { name: 'Customer First', desc: 'Relationships that last beyond project completion.' },
  { name: 'Sustainability', desc: 'Responsible development with environmental consciousness.' },
];

export const PHILOSOPHY = [
  { step: '01', title: 'Acquire the Right Land', desc: 'Carefully select strategic locations with high growth potential.' },
  { step: '02', title: 'Plan Responsibly', desc: 'Thoughtful planning, legal compliance and future-ready infrastructure.' },
  { step: '03', title: 'Build Sustainably', desc: 'Communities that enhance lifestyles while respecting the environment.' },
  { step: '04', title: 'Deliver Beyond Expectations', desc: 'Quality construction, timely delivery, complete satisfaction.' },
];

export const PROJECTS = [
  // ONGOING DEVELOPMENTS
  { id: 'manavi-villas', name: 'Manavi Homes Villas', location: 'Shankarpally', meta: '4 Acres', type: 'Premium Villa Community', status: 'Ongoing', img: '/assets/projects/manavi.jpeg' },
  { id: 'flora', name: 'FLORA Apartments', location: 'Sullurpeta', meta: '2.5 Acres', type: 'Premium Apartment Project', status: 'Ongoing', img: '/assets/projects/sandy-springs.webp' },

  // COMPLETED LANDMARKS (COMMERCIAL ON TOP)
  { id: 'oak-plaza', name: 'OAK Plaza', location: 'Khajaguda', meta: '1,600 Sq. Yds · 5 Floors', type: 'Commercial', status: 'Completed', img: '/assets/projects/oak-plaza.webp' },
  { id: 'soucha-marvel', name: 'Soucha Marvel', location: 'Khajaguda', meta: '1,500 Sq. Yds · 5 Floors', type: 'Commercial', status: 'Completed', img: '/assets/projects/soucha-marvel.webp' },
  { id: 'arnav', name: 'Arnav Apartments', location: 'Manikonda', meta: '20 Units · 5 Floors', type: '2 & 3 BHK Apartments', status: 'Completed', img: '/assets/projects/arnav.webp' },
  { id: 'sri-datta-sai', name: "Sri Datta Sai Nilayam", location: 'Manikonda', meta: '20 Units · 4 Floors', type: '2 & 3 BHK Apartments', status: 'Completed', img: '/assets/projects/sri-datta-sai.webp' },
  { id: 'tulasi-garden', name: 'Tulasi Garden', location: 'Manikonda', meta: '20 Units · 4 Floors', type: '2 & 3 BHK Apartments', status: 'Completed', img: '/assets/projects/tulasi-garden.webp' },
  { id: 'sita-symphony', name: 'Sita Symphony', location: 'Khajaguda', meta: '35 Units · 5 Floors', type: 'Premium 3 BHK Apartments', status: 'Completed', img: '/assets/projects/sita-symphony.webp' },
  { id: 'sandy-springs', name: 'Sandy Springs', location: 'Manikonda', meta: '160 Units · 5 Floors', type: 'Premium 3 BHK Apartments', status: 'Completed', img: '/assets/projects/flora.webp' },
];

export const UPCOMING = [
  {
    id: 'upcoming-alwal',
    name: 'Alwal',
    location: 'Alwal',
    meta: 'Residential',
    type: 'Premium Residential Apartments',
    status: 'Upcoming',
    img: '/assets/projects/alwal.jpeg',
  },
  {
    id: 'upcoming-singapur',
    name: 'Singapur',
    location: 'Shankarpally',
    meta: 'Villa Community',
    type: 'Luxury Villa Community',
    status: 'Upcoming',
    img: '/assets/projects/singapur.jpeg',
  },
];

export const PLOT_DEVELOPMENTS = [
  { id: 'plot-manavi-homes', name: 'Manavi Homes', location: 'Fatehpur', meta: '18 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/Mavavihomes.jpeg' },
  { id: 'nalagandla', name: 'Nallagandla Project', location: 'Nallagandla', meta: '2.5 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/nalagandla.jpeg' },
  { id: 'plot-mulkapur', name: 'Mulkapur', location: 'Dharamsagar', meta: '100 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/mulkapur 111.jpeg' },
  { id: 'plot-vittal-rao', name: 'Vittal Rao Nagar', location: 'Madhapur', meta: '5 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/vittal rao nagar.jpeg' },
  { id: 'plot-chaitanya', name: 'Chaitanya Enclave', location: 'Khajaguda', meta: '8 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/chaitanya.jpeg' },
  { id: 'plot-brundavan', name: 'Brundavan Colony', location: 'Narsingi', meta: '8 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/brundavan.jpeg' },
  { id: 'plot-neknampur', name: 'Neknampur', location: 'Manikonda', meta: '12 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/neknampur.jpeg' },
  { id: 'plot-kpr', name: 'KPR Colony', location: 'Manikonda', meta: '8 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/kpr colony.jpeg' },
  { id: 'plot-kandhawada', name: 'Kandhawada', location: 'Chevella', meta: '40 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/kandhawada.jpeg' },
  { id: 'plot-thangadpally-75', name: 'Thangadpally', location: 'Thangadpally', meta: '75 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/thangadpally.jpeg' },
  { id: 'plot-thangadpally-15', name: 'Natures Creek', location: 'Thangadpally', meta: '15 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/naturescreek.jpeg' },
  { id: 'plot-mallepally', name: 'Mallepally', location: ' Nagarjuna Sagar Road', meta: '114 Acres', type: 'Plotted Development', status: 'Completed', img: '/assets/projects/mallepalli mango frams.jpeg' },
];

export const TIMELINE = [
  { phase: 'The Foundation', title: 'Plotted Developments at Scale', desc: '405+ acres of premium plotted layouts across Telangana — anchored by 100 acres at Dharamsagar, Mulkapur and growth corridors from Kandhawada to Mallepally.' },
  { phase: 'Residential Rise', title: 'The Manikonda Era', desc: 'Arnav, Sri Datta Sai Nilayam, Tulasi Garden and the 160-unit Sandy Springs — 220+ quality homes delivered in one of Hyderabad\'s fastest corridors.' },
  { phase: 'Premium & Commercial', title: 'Khajaguda Expansion', desc: 'Sita Symphony premium residences, Nallagandla development, and commercial landmarks OAK Plaza & Soucha Marvel.' },
  { phase: 'Today', title: 'Three Ongoing Developments', desc: 'Manavi Homes — 18-acre plotted development at Fatehpur, Manavi Villas at Shankarpally and FLORA Apartments at Sullurpeta.' },
  { phase: 'Tomorrow', title: 'The Next Chapter', desc: 'Premium residential apartments at Alwal and a luxury villa community at Singapur, Shankarpally.' },
];

export const CHART_BARS = [
  { label: 'Acres', value: 405, suffix: '+', h: 2.9 },
  { label: 'Completed', value: 21, suffix: '+', h: 2.2 },
  { label: 'Ongoing', value: 3, suffix: '', h: 1.05 },
  { label: 'Upcoming', value: 2, suffix: '', h: 0.75 },
  { label: 'Locations', value: 14, suffix: '', h: 2.05 },
];

export const LOCATIONS = [
  'Manikonda', 'Khajaguda', 'Shankarpally', 'Gandipet', 'Madhapur',
  'Narsingi', 'Neknampur', 'Alwal', 'Sullurpeta', 'Sangareddy', 'Mulkapur', 'Fatehpur', 'Nallagandla',
];
